<template>
  <VModal class="modal-wrapper" :color="ColorType.brand2" :type="ModalType.custom">
    <VBlock class="wrapper" :direction="Direction.column">
      <!-- TODO implement src/components/order/LoginModal.vue:5 -->
      <VImage
        :type="ImageType.bg"
        class="login-icon"
        :src="resources.loginIcon"
        :width="130"
        :height="100"
      />
      <VButton
        class="login-button"
        :color="ButtonColor.white"
        :onClick="params.onLogin"
        :radius="30"
      >
        <VSpan class="login-text" text="로그인" :size="16" :weight="TextWeight.bold" />
      </VButton>
      <VButton :color="ButtonColor.none" :onClick="onOK">
        <VSpan class="text" :color="TextColor.white" text="비회원으로 주문하기" :size="16" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'

import VImage, { ImageType } from '@/presentationals/v2/components/layouts/atoms/VImage'
import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal, {
  ColorType,
  ModalType
} from '@/presentationals/v2/components/layouts/molecules/VModal'
import VA from '../../molecules/VA'

import loginIcon from '@/assets/images/img-login.png'

export default {
  name: 'ModalLogin',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VA,
    VButton,
    VSpan,
    VHR,
    VImage,

    VBlock,
    VModal
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ColorType,
      ModalType,
      ImageType,

      resources: {
        loginIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.modal-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
  padding: 40px 40px calc(constant(safe-area-inset-bottom) + 40px) 40px;
  padding: 40px 40px calc(env(safe-area-inset-bottom) + 40px) 40px;

  .wrapper {
    width: 100%;
    box-sizing: border-box;

    .login-button {
      width: 180px;
      padding: 12px 24px 12px 24px;
      margin-bottom: 16px;
    }

    // .none-login-order-button {
    //   .text {

    //   }
    // }

    .login-icon {
      background-position: bottom;
    }
  }
}
</style>
